import React from 'react';
import NewBMLastStep from './NewBMLastStep';

const NewBMLastStepContainer = ({ formikProp, loading }) => {
  return <NewBMLastStep formikProp={formikProp} loading={loading} />;
};

export default NewBMLastStepContainer;
